// extracted by mini-css-extract-plugin
export var aniSpin = "c_d";
export var smallWidth = "c_f";